export default __webpack_public_path__ + "static/media/downArrow.c18d0bad.svg";